export enum GENDER {
  MR = 'MR',
  MRS = 'MRS',
  MS = 'MS',
  OTHER = 'OTHER',
}

export type Gender = (typeof GENDER)[keyof typeof GENDER];
